<template>
    <section class="view" v-if="hasPermissions(['Facility Read'])">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is the record for your Facility. Typically, there is only one record. To modify, click into a field, type the changed field and click "Save & Close"
            </p>
        </div>
        <div>
           <form class="col-12 p-0" @submit.prevent="exist ? form_submit_update(facility.id) : form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="facility"
                    :array_options="array_options"
                    :for_update="exist ? true : false"
                />
                <div class="col-md-12 p-0 formdynamic__item pt-3" v-show="false">
                    <div class="form-group space-top">
                      <label v-html="'File'" class="modal-label" />
                      <input
                        type="file"
                        ref="file_input"
                        :class="'form-control'"
                        style="height: 2rem; font-size:12px; color:black;"
                        @change="file_upload($event)"
                        accept=".xlsx"
                      />
                    </div>
                </div>
                <CentralLiteButtons
                    v-if="hasPermissions(['Facility Write'])" 
                    :not_show_cancel="true"
                    :type="''"
                    @Cancelation="form_cancel()"
                />
           </form>
        </div>
        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import CentralLiteButtons       from    '@/components/CentralLiteButtons'
import WaitingModal             from    '@/components/WaitingModal'
import Resources                from    './resources'
import FormDynamic              from    '@/components/FormDynamic.vue'
import UnauthorizedComponent    from   '@/components/UnauthorizedComponent'
import FormResources            from    './form_resources'
import xlsx                     from    'xlsx';
import 'vuetify/dist/vuetify.min.css'
import { Notyf }         from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
const reader = new FileReader();
export default {

    name: "Facility",
    components: {
        Breadcrumb,
        WaitingModal,
        FormDynamic,
        CentralLiteButtons,
        UnauthorizedComponent,
    },

    data() {
        return {
            notyf,
            axios,
            title_page:         'Facility',
            rest_api:           `facility`,
            breadcrumb:         Resources.breadcrumb,
            form_data:          FormResources.form_data,
            form_format:        FormResources.form_format,
            exist:              false,
            facility:           FormResources.form_data,
            facility_backup:    {},
            array_options:      {},
            user:               this.get_user(),
            reader,
            upload_data:        null,
            first_time: true
        }
    },

    watch: {

        async 'facility.country_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:                 val,
                    states_request:     true,
                    cities_request: false
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                
                if(response.status)
                {
                    if(response.data.states.length)
                    {
                        this.array_options['state_id'] = response.data.states
                        let states_object = this.array_options.state_id.find( (key) =>
                        {
                            return key.id === this.facility_backup.state_id 
                        })
                        states_object === undefined 
                        ? this.facility.state_id = (this.first_time) ? '' : this.array_options.state_id[0].id
                        : this.facility.state_id = states_object.id
                    }
                    else
                    {
                        this.array_options.state_id = []
                        notyf.error('States unavailable')  
                        this.facility.state_id      = '' 
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
            this.first_time = false
        },
        async 'facility.state_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:                 val,
                    states_request:     false,
                    cities_request: true
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                
                if(response.status)
                {
                    if(response.data.cities.length)
                    {
                        this.array_options['city_id'] = response.data.cities

                        let cities_object = this.array_options.city_id.find( (key) =>
                        {
                            return key.id === this.facility_backup.city_id 
                        })
                        cities_object === undefined 
                        ? this.facility.city_id = (this.first_time) ? '' : this.array_options.city_id[0].id 
                        : this.facility.city_id = cities_object.id
                    }
                    else
                    {
                        this.array_options.city_id = []
                        notyf.error('Cities unavailable')
                        this.facility.city_id      = ''
                    }
                    
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },
    },

    methods:
    {  
        form_cancel()
        {
            if(this.exist)
            {
                this.facility = {...this.facility_backup}
                return true
            }
            this.facility = {...this.form_data}
        },

        async form_submit()
        {
            let response  = await this.queryGetByMethod(this.rest_api, this.facility, 'post')
            this.after_submit(response)
        },
        
        async form_submit_update(id)
        {
            let response  = await this.queryGetByMethod(`${this.rest_api}/${id}`, this.facility)
            this.after_submit(response)
        },

        after_submit(response)
        {
            if(response.status)
            {
                this.exist = true
                if(response.data.user !== undefined) 
                {
                    localStorage.setItem('user', JSON.stringify(response.data.user))
                }
                this.facility = response.data.facility
                this.facility_backup = {...response.data.data}
                notyf.success('Success')
            }
            else
            {
                this.error_handling(response)
            }
        },

        fill_data(data)
        {
            if(data.facility !== '')
            {   
                this.exist           = true
                this.facility        = data.facility
                this.facility_backup = {...data.facility}
                if(!this.facility.city_id)
                {
                    this.facility.country_id = 233
                }
            }
            this.array_options = {
                country_id:     data.territories,
                logo: ['image/jpeg', 'image/png', 'image/jpg', 'image/svg', 'image/ico', 'image/webp'],
                state_id:   [],
                city_id:   [],
                timezone_id: data.timezones
            }
        },

        file_upload(event)
        {
            const file = event.target.files[0]
            if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            {
                reader.readAsBinaryString(file)
                reader.onload = (e) => {
                    this.upload_data = this.get_content(e.target.result)
                }
                this.notyf.success("The file is compatible")
            }
            else 
            {
                this.notyf.error("The file is not compatible")
                return false
            }
        },

        get_content(data) {
            const content = xlsx.read(data, { type: 'binary' });
            const sheets = content.SheetNames
            const obj = {}
            sheets.forEach(sheet => {
                obj[sheet] = xlsx.utils.sheet_to_json(content.Sheets[sheet])
            })
            return obj
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Facility Read']))
        {
            await this.api_request();
        }
        else
        {
            window.location.href = '/'
        }

    }
};
</script>